import { isArray } from "underscore";
import System from "./system";

const { avUserInfoData } = System

class RoleAndPermission {

    static alertPermission = {
        AL_VIEW: { slug: 'AL_VIEW', status: true, isLogin: false, isGuest: true }
    }

    static bomPermission = {
        BOM_ADD_TO_QUOTE: { slug: 'BOM_ADD_TO_QUOTE', status: true, isLogin: false, isGuest: true },
        BOM_ADD_TO_CART: { slug: 'BOM_ADD_TO_CART', status: true, isLogin: false, isGuest: true },
        VIEW_BOM: { slug: 'VIEW_BOM', status: true, isLogin: false, isGuest: true }
    }

    static checkoutPermission = {
        CKOT_PAYMENT_METHOD_BOX: { slug: 'CKOT_PAYMENT_METHOD_BOX', status: true, isLogin: false, isGuest: true },
        CKOT_ORDER_PLACED_BOX: { slug: 'CKOT_ORDER_PLACED_BOX', status: true, isLogin: false, isGuest: true },
        CKOT_VIEW: { slug: 'CKOT_VIEW', status: true, isLogin: false, isGuest: true },
        CHECKOUT_PLACE_ORDER_BUTTON: { slug: 'CHECKOUT_PLACE_ORDER_BUTTON', status: true, isLogin: false, isGuest: true }
    }

    static comparePermission = {
        CP_ADD_TO_CART: { slug: 'CP_ADD_TO_CART', status: true, isLogin: false, isGuest: true },
        CP_CLICK_TO_QUOTE: { slug: 'CP_CLICK_TO_QUOTE', status: true, isLogin: false, isGuest: true },
        CP_VIEW_CART: { slug: 'CP_VIEW_CART', status: true, isLogin: false, isGuest: true },
        CPG_CLICK_TO_QUOTE: { slug: 'CPG_CLICK_TO_QUOTE', status: true, isLogin: false, isGuest: true }
    }

    static forecastPermission = {
        VIEW_FORECAST: { slug: 'VIEW_FORECAST', status: true, isLogin: false, isGuest: true }
    }

    static orderPermission = {
        ORDER_HISTORY: { slug: 'ORDER_HISTORY', status: true, isLogin: false, isGuest: true }
    }

    static productPermission = {
        PD_ADD_TO_CART: { slug: 'PD_ADD_TO_CART', status: true, isLogin: false, isGuest: true },
        PD_ADD_TO_BOM: { slug: 'PD_ADD_TO_BOM', status: true, isLogin: false, isGuest: true },
        PD_CLICK_TO_QUOTE: { slug: 'PD_CLICK_TO_QUOTE', status: true, isLogin: false, isGuest: true },
        PD_CONTACT_US: { slug: 'PD_CONTACT_US', status: true, isLogin: false, isGuest: true },
        PD_VIEW_CART: { slug: 'PD_VIEW_CART', status: true, isLogin: false, isGuest: true },
        PD_SIGN_IN_ABACUS_PRICE: { slug: 'PD_SIGN_IN_ABACUS_PRICE', status: true, isLogin: false, isGuest: true },
        PDG_ADD_TO_CART: { slug: 'PDG_ADD_TO_CART', status: true, isLogin: false, isGuest: true },
        PDG_ADD_TO_BOM: { slug: 'PDG_ADD_TO_BOM', status: true, isLogin: false, isGuest: true },
        PDG_CLICK_TO_QUOTE: { slug: 'PDG_CLICK_TO_QUOTE', status: true, isLogin: false, isGuest: true },
        PDG_VIEW_CART: { slug: 'PDG_VIEW_CART', status: true, isLogin: false, isGuest: true }
    }

    static productDetailPermission = {
        PDT_VIEW_CART: { slug: 'PDT_VIEW_CART', status: true, isLogin: false, isGuest: true },
        PDT_ADD_TO_CART: { slug: 'PDT_ADD_TO_CART', status: true, isLogin: false, isGuest: true },
        PDT_ADD_TO_BOM: { slug: 'PDT_ADD_TO_BOM', status: true, isLogin: false, isGuest: true },
        PDT_CLICK_TO_QUOTE: { slug: 'PDT_CLICK_TO_QUOTE', status: true, isLogin: false, isGuest: true },
        PDTG_VIEW_CART: { slug: 'PDTG_VIEW_CART', status: true, isLogin: false, isGuest: true },
        PDTG_ADD_TO_CART: { slug: 'PDTG_ADD_TO_CART', status: true, isLogin: false, isGuest: true },
        PDTG_ADD_TO_BOM: { slug: 'PDTG_ADD_TO_BOM', status: true, isLogin: false, isGuest: true },
        PDTG_CLICK_TO_QUOTE: { slug: 'PDTG_CLICK_TO_QUOTE', status: true, isLogin: false, isGuest: true }
    }

    static quotePermissions = {
        QT_VIEW: { slug: 'QT_VIEW', status: true, isLogin: false, isGuest: true }, // Submitted Quotes
        OPEN_QT_VIEW: { slug: 'OPEN_QT_VIEW', status: true, isLogin: false, isGuest: true }, // Open Quotes
        QT_BUY_NOW: { slug: 'QT_BUY_NOW', status: true, isLogin: false, isGuest: true },
        QT_CART_VIEW: { slug: 'QT_CART_VIEW', status: true, isLogin: false, isGuest: true },
        QT_CHECKOUT: { slug: 'QT_CHECKOUT', status: true, isLogin: false, isGuest: true }
    };

    static roles = {
        ZX: "ZX",
        ZU: "ZU",
        ZA: "ZA",
        ZS: "ZS",
        ZE: "ZE",
        ZJ: "ZJ",
        ZI: "ZI",
        FSP: "FSP",
        ExternalSales: "ExternalSales",
        AuthAccountLess: "AuthAccountLess",
        SuperAdmin: "SuperAdmin"
    }

    static getPermissionByRole = (roleType) => {
        let activePermissions = {}

        if (roleType === this.roles.AuthAccountLess) {
            activePermissions = {
                [this.productPermission.PD_ADD_TO_BOM.slug]: this.productPermission.PD_ADD_TO_BOM,
                [this.productDetailPermission.PDT_ADD_TO_BOM.slug]: this.productDetailPermission.PDT_ADD_TO_BOM,
                [this.bomPermission.VIEW_BOM.slug]: this.bomPermission.VIEW_BOM,
                ...this.comparePermission,
                ...this.forecastPermission
            }
        } else if (roleType === this.roles.ExternalSales) {
            activePermissions = {
                ...this.productPermission,
                ...this.forecastPermission,
                ...this.productDetailPermission,
                ...this.comparePermission,
                ...this.alertPermission,
                ...this.bomPermission,
                ...this.orderPermission,
                ...this.quotePermissions,
                [this.checkoutPermission.CKOT_VIEW.slug]: this.checkoutPermission.CKOT_VIEW,
                [this.checkoutPermission.CKOT_ORDER_PLACED_BOX.slug]: this.checkoutPermission.CKOT_ORDER_PLACED_BOX
            }
        } else if (roleType === this.roles.FSP || roleType === this.roles.SuperAdmin) {
            activePermissions = {
                ...this.productPermission,
                ...this.forecastPermission,
                ...this.productDetailPermission,
                ...this.comparePermission,
                ...this.alertPermission,
                ...this.bomPermission,
                ...this.checkoutPermission,
                ...this.orderPermission,
                ...this.quotePermissions
            }
        } else if (roleType === this.roles.ZA || roleType === this.roles.ZE || roleType === this.roles.ZI || roleType === this.roles.ZJ || roleType === this.roles.ZS) {
            activePermissions = {
                ...this.productPermission,
                ...this.forecastPermission,
                ...this.productDetailPermission,
                ...this.comparePermission,
                ...this.alertPermission,
                ...this.bomPermission,
                ...this.orderPermission,
                ...this.quotePermissions,
                [this.checkoutPermission.CKOT_VIEW.slug]: this.checkoutPermission.CKOT_VIEW,
                [this.checkoutPermission.CKOT_ORDER_PLACED_BOX.slug]: this.checkoutPermission.CKOT_ORDER_PLACED_BOX
            }
        } else if (roleType === this.roles.ZU) {
            activePermissions = {
                ...this.productPermission,
                ...this.forecastPermission,
                ...this.productDetailPermission,
                ...this.comparePermission,
                ...this.alertPermission,
                ...this.bomPermission,
                ...this.orderPermission,
                ...this.quotePermissions,
                ...this.checkoutPermission
            }
        } else if (roleType === this.roles.ZX) {
            activePermissions = {
                ...this.forecastPermission,
                ...this.orderPermission,
                ...this.alertPermission,
                [this.productPermission.PDG_ADD_TO_CART.slug]: this.productPermission.PDG_ADD_TO_CART,
                [this.productPermission.PDG_ADD_TO_BOM.slug]: this.productPermission.PDG_ADD_TO_BOM,
                [this.productPermission.PDG_CLICK_TO_QUOTE.slug]: this.productPermission.PDG_CLICK_TO_QUOTE,
                [this.productPermission.PDG_VIEW_CART.slug]: this.productPermission.PDG_VIEW_CART,
                [this.productPermission.PD_ADD_TO_BOM.slug]: this.productPermission.PD_ADD_TO_BOM,
                [this.productDetailPermission.PDTG_ADD_TO_CART.slug]: this.productPermission.PDTG_ADD_TO_CART,
                [this.productDetailPermission.PDTG_ADD_TO_BOM.slug]: this.productPermission.PDTG_ADD_TO_BOM,
                [this.productDetailPermission.PDTG_CLICK_TO_QUOTE.slug]: this.productPermission.PDTG_CLICK_TO_QUOTE,
                [this.productDetailPermission.PDTG_VIEW_CART.slug]: this.productPermission.PDTG_VIEW_CART,
                [this.productDetailPermission.PDT_ADD_TO_BOM.slug]: this.productPermission.PDT_VIEW_CART,
                [this.bomPermission.VIEW_BOM.slug]: this.bomPermission.VIEW_BOM,
                [this.quotePermissions.QT_VIEW.slug]: this.quotePermissions.QT_VIEW,
                [this.quotePermissions.OPEN_QT_VIEW.slug]: this.quotePermissions.OPEN_QT_VIEW
            }
        }
        return activePermissions
    }

    static loadPermissionBasedOnAuthRole () {
        const r = avUserInfoData?.email ? avUserInfoData?.roles?.length ? avUserInfoData.roles : [ this.roles.AuthAccountLess ] : [];
        const p = [];

        if (r && isArray(r) && r.length > 0) {
            r.map((v) => {
                const activePermissions = this.getPermissionByRole(v)

                if (activePermissions && Object.entries(activePermissions).length > 0) {
                    Object.entries(activePermissions).map((v_inner) => {
                        p.push(v_inner[0])
                    })
                }
            })
        }
        window.active_permissions = p;
        return p;
    }

    // static checkActivePermission (slug) {
    //         if (window.active_permissions.includes(slug)) {
    //             return true;
    //         }
    //     return false;
    // }
}

export default RoleAndPermission;